import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitFilterPlannedStatus = createSelector(
  [selectFinancialCockpitState],
  ({ filter }) => filter.plannedStatus
)
